import getEducationLevel from '@/utils/EducationLevelUtils';
import {
	AttendanceFilterValue,
	EducationLevelFilterValue,
	ProgrammeSearchInput
} from '@studyportals/search-api-interface';

const getPortalFacetFilter = (): ProgrammeSearchInput => {
	const educationalLevels = getEducationLevel();
	const isDistanceLearning = educationalLevels?.[0] === EducationLevelFilterValue.DISTANCE_LEARNING;

	const portalFilter: ProgrammeSearchInput = isDistanceLearning
		? { attendances: [AttendanceFilterValue.ONLINE, AttendanceFilterValue.BLENDED] }
		: { educationalLevels };

	return portalFilter;
}

export default getPortalFacetFilter;